import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdDownload,
  MdForwardToInbox,
  MdOutlineAlternateEmail,
  MdOutlineBadge,
  MdOutlineCall,
  MdReportGmailerrorred,
} from "react-icons/md";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import InsurancePlan from "./InsurancePlan";
import validation from "./validation";

const Initial = ({
  data,
  onSendQuote,
  onDownload,
  onCheck,
  onJustify,
  justifications,
  selectedData,
  translation,
  insurancePlans = [],
  addLinks,
  setAddLinks,
  onCopyLink,
  initialValues,
  upsells,
  onSubmit,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues,
    onSubmit: onSubmit,
    enableReinitialize: true,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  const submitForm = () => {
    return new Promise((resolve, reject) => {
      handleSubmit();
      onSubmit(values).then(resolve).catch(reject);
    });
  };

  const handleDownload = () => {
    onDownload(submitForm);
  };

  const handleSendQuote = () => {
    onSendQuote(submitForm);
  };

  return (
    <div className="grid--1">
      <div>
        <div className="download__header">{translation.TITLE}</div>
      </div>
      <div className="grid--1">
        <Alert
          type="info"
          showIcon
          message={translation.SUGGESTION}
          icon={<MdReportGmailerrorred size={16} />}
        />
        {data.map((item, index) => (
          <div key={"product-" + index}>
            <InsurancePlan
              onCheck={(state) => onCheck(item?.insurancePlan?.id, state)}
              checked={[...selectedData, ...insurancePlans].includes(
                item?.insurancePlan?.id,
              )}
              logo={item.insurancePlan.icon}
              name={item.insurancePlan.name}
              description={item.insurancePlan.description}
              cost={item.cost}
              currency={item.currency}
              translation={translation}
              justification={justifications[item?.insurancePlan?.id]}
              onJustify={(justification) =>
                onJustify(justification, item?.insurancePlan?.id)
              }
              checkDisabled={selectedData.length > 3}
              disabled={insurancePlans.includes(item?.insurancePlan?.id)}
              upsells={get(upsells, item.insurancePlan.id, []).sort((a, b) =>
                b?.insurancePlan?.name.localeCompare(a?.insurancePlan?.name),
              )}
            />
          </div>
        ))}
      </div>

      <div className="subscription-form--wrapper">
        <Form
          type="vertical"
          title="Informations de contact"
          subtitle="Renseignez vos coordonnées pour l'envoi de votre devis"
        >
          <Row gutter={[16, 16]}>
            <Col lg={12} xs={24}>
              <Input
                placeholder="Ex : Bernard"
                label="Prénom"
                icon={<MdOutlineBadge size={16} />}
                {...bindInputProps({
                  name: "contact.user.firstname",
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue("contact.user.firstname", value);
                }}
              />
            </Col>
            <Col lg={12} xs={24}>
              <Input
                label="Nom"
                icon={<MdOutlineBadge size={16} />}
                placeholder="Ex : Doe"
                {...bindInputProps({
                  name: "contact.user.lastname",
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue("contact.user.lastname", value);
                }}
              />
            </Col>
            <Col lg={12} xs={24}>
              <Input
                label="N° de téléphone"
                icon={<MdOutlineCall size={16} />}
                placeholder="Ex : 06 10 20 30 40"
                {...bindInputProps({
                  name: `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue(
                    `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                    value,
                  );
                }}
              />
            </Col>
            <Col lg={12} xs={24}>
              <Input
                label="Adresse email"
                icon={<MdOutlineAlternateEmail size={16} />}
                placeholder="Ex : exemple@domaine.fr"
                {...bindInputProps({
                  name: `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                onChange={({ target: { value } }) => {
                  setFieldValue(
                    `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                    value,
                  );
                }}
              />
            </Col>
          </Row>
        </Form>
      </div>

      <div className="download__actions">
        <div className="download__actions--container">
          <Button
            onClick={handleDownload}
            disabled={!selectedData.length || !isEmpty(formProps.errors)}
            type="primary--outlined"
            size="full--width"
          >
            {translation.DOWNLOAD}
            <MdDownload size={16} />
          </Button>
          {/* <div className="download__actions--copy" onClick={onCopyLink}>
            {translation.COPY}
          </div> */}
        </div>
        <span className="download__actions--or">{translation.OR}</span>
        <div className="download__actions--container">
          <Button
            onClick={handleSendQuote}
            disabled={!selectedData.length || !isEmpty(formProps.errors)}
            type="primary"
            size="full--width"
          >
            {translation.SEND_BY_EMAIL}
            <MdForwardToInbox size={16} />
          </Button>

          {/* <Input
            type="checkbox"
            label={translation.ADD_LINKS}
            checked={addLinks}
            onChange={({ target: { checked } }) => {
              setAddLinks(checked);
            }}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Initial;
